import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccessRestrictedDialogComponent } from './access-dialog.component';
import { AccessRestrictedComponent } from './access.component';
import { FeatureInfoService } from './feature-info.service';
import { RestrictedContentComponent } from './restricted-content/restricted-content.component';
import { RestrictedContentDialogComponent } from './restricted-content/restricted-content-dialog.component';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatCard, MatCardContent } from '@angular/material/card';
import { StartTrialBannerComponent } from '../start-trial-banner/start-trial-banner.component';

const materialComponents = [MatIconModule, MatButtonModule, MatDialogModule];
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ...materialComponents,
    TranslateModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MatCard,
    MatCardContent,
    RestrictedContentComponent,
    RestrictedContentDialogComponent,
    StartTrialBannerComponent,
  ],
  exports: [AccessRestrictedComponent, AccessRestrictedDialogComponent],
  declarations: [AccessRestrictedComponent, AccessRestrictedDialogComponent],
  providers: [FeatureInfoService],
})
export class AccessModule {}
